<template>
    <div class="app-container">
        <el-row id="queryForm">
            <el-form :inline="true" ref="queryForm" :model="queryForm" @submit.native.prevent>
                <el-form-item prop="querySelectedValue">
                    <el-input clearable placeholder="请输入内容" v-model="queryForm.querySelectedValue" class="input-with-select">
                        <el-select v-model="queryForm.querySelectedType" slot="prepend" placeholder="请选择">
                            <el-option label="媒介名称" value="value"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="dataRange">
                    <el-date-picker clearable v-model="queryForm.dataRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </el-form-item>
                <el-form-item class="floatRight">
                    <el-dropdown split-button type="primary" @click="queryData" @command="handleCommand">
                        查询
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="reset">重置查询</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="marginBottom-8" id="addBtnRow">
            <el-button type="primary" @click="addMediaType">新增媒介</el-button>
        </el-row>
        <el-table :max-height="tableHeight" v-loading="listLoading" element-loading-text="加载中" :data="list" border fit highlight-current-row>
            <el-table-column label="媒介编号" align="center">
                <template slot-scope="scope">
                    {{ scope.row.flowId }}
                </template>
            </el-table-column>
            <el-table-column label="创建人" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="queryUserInfo(scope.row.userCode)">{{ scope.row.userCode }}</el-button>
                </template>
            </el-table-column>
            <el-table-column label="媒介名称" align="center">
                <template slot-scope="scope">
                    {{ scope.row.value }}
                </template>
            </el-table-column>
            <el-table-column label="添加时间" align="center">
                <template slot-scope="scope">
                    <span>{{ moment(scope.row.addTime).format("YYYY-MM-DD HH:mm:ss") }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-popconfirm title="确定删除吗？" @confirm="del(scope.row.flowId)">
                        <el-button :disabled="userInfo.userCode != scope.row.userCode" slot="reference" type="text" size="small">删除</el-button>
                    </el-popconfirm>
                    <el-button :disabled="userInfo.userCode != scope.row.userCode" class="marginLeft-8" type="text" size="small" @click="edit(scope.row.flowId)">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="marginTop-8 floatRight" layout="total, sizes, prev, pager, next" background :current-page="queryForm.pageNum + 1" :page-size="queryForm.pageSize" :total="queryForm.totalCount" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        <MediaTypeAdd :op="op" @onDialogClose="onDialogClose" :visible="diaLogShow" />
        <UserInfo :visible="drawerVisible" :userCode="userCode" @closeDrawer="closeDrawer" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getMediaTypePageList, systempropertiesDelete } from "@/api/statisticalReport";
import { computeTableHeight, regionData, CodeToText, } from "@/utils";
import state from "@/utils/state";
import moment from "moment";
import MediaTypeAdd from "./components/AddMediaType";
import UserInfo from "@/components/UserInfo";

export default {
    components: {
        MediaTypeAdd,
        UserInfo,
    },
    data() {
        return {
            tableHeight: 0,
            drawerVisible: false,
            userCode: null,
            options: regionData,
            listLoading: true,
            list: [],
            mediaList: [],
            moment,
            diaLogShow: false,
            op: "add",
            queryForm: {
                querySelectedType: "value",
                querySelectedValue: "",
                region: "",
                reviewResults: "",
                dataRange: "",
                mediaCode: "",
                pageNum: 0,
                pageSize: 10,
                totalCount: 0,
            },
        };
    },
    computed: {
        state() {
            return state.state;
        },
        ...mapGetters(["userInfo"]),
    },
    created() {
        this.fetchData();
    },
    mounted() {
        const _this = this;
        this.$nextTick(() => {
            _this.tableHeight = computeTableHeight();
        });
        window.addEventListener("resize", () => {
            _this.tableHeight = computeTableHeight();
        });
    },
    methods: {
        closeDrawer() {
            this.drawerVisible = false;
            this.userCode = null;
        },
        queryUserInfo(userCode) {
            this.userCode = userCode;
            this.drawerVisible = true;
        },
        addMediaType() {
            this.diaLogShow = true;
        },
        del(flowId) {
            let params = {
                flowId: flowId,
            };
            const _this = this;
            systempropertiesDelete(params)
                .then(() => {
                    _this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    _this.fetchData();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleClick(e) {
            this.fetchData();
        },
        onDialogClose(refeshFlag) {
            this.diaLogShow = false;
            this.op = "add";
            if (refeshFlag == true) {
                this.fetchData();
            }
        },
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.fetchData();
        },
        handleCurrentChange(val) {
            this.queryForm.pageNum = val - 1;
            this.fetchData();
        },
        edit(flowId) {
            this.op = flowId;
            this.addMediaType();
        },
        handleCommand(type) {
            if (type == "reset") {
                this.$refs.queryForm.resetFields();
                this.fetchData();
            }
        },
        queryData() {
            this.fetchData();
        },
        fetchData() {
            this.listLoading = true;
            const queryForm = this.queryForm;
            let params = {
                pageNum: queryForm.pageNum,
                pageSize: queryForm.pageSize,
                type: 1,
            };
            if (queryForm.querySelectedValue && queryForm.querySelectedValue != "") {
                params[queryForm.querySelectedType] = queryForm.querySelectedValue;
            }
            if (queryForm.reviewResults && queryForm.reviewResults != "") {
                params.reviewResults = queryForm.reviewResults;
            }
            if (queryForm.mediaCode && queryForm.mediaCode != "") {
                params.mediaCode = queryForm.mediaCode;
            }
            if (queryForm.dataRange && queryForm.dataRange != "") {
                params.maxAddTime = moment(queryForm.dataRange[1]).format("YYYY-MM-DD") + " 23:59:59";
                params.minAddTime = moment(queryForm.dataRange[0]).format("YYYY-MM-DD") + " 00:00:00";
            }
            if (queryForm.region.length == 1) {
                params.province = CodeToText[queryForm.region[0]];
            } else if (queryForm.region.length == 2) {
                params.province = CodeToText[queryForm.region[0]];
                params.city = CodeToText[queryForm.region[1]];
            } else if (queryForm.region.length == 3) {
                params.province = CodeToText[queryForm.region[0]];
                params.city = CodeToText[queryForm.region[1]];
                params.district = CodeToText[queryForm.region[2]];
            }
            const _this = this;
            getMediaTypePageList(params)
                .then((response) => {
                    _this.list = response.data.dataList;
                    _this.queryForm.totalCount = response.data.totalCount;
                    _this.listLoading = false;
                })
                .catch((err) => {
                    _this.listLoading = false;
                });
        },
    },
};
</script>
